// Import de bibliotecas principais
import React, { useState, useEffect } from 'react'
import { useQuery, gql } from '@apollo/client'

// Import de elementos de estilização, componentes gerais e de layout
import { motion } from 'framer-motion/dist/framer-motion'
import { Logo } from '../../../components/main'
import { Link } from 'react-router-dom'

import { ReactSVG as SVG } from 'react-svg'
import facebookIcon from '../../../assets/svg/facebook.svg'
import instagramIcon from '../../../assets/svg/instagram.svg'
import linkedinIcon from '../../../assets/svg/linkedin.svg'
import vemSerIcon from '../../../assets/svg/vem-ser.svg'

import './Footer.scss'

const footerQuery = gql`
	query FooterQuery {
		acfOptionsDefinicoes {
			gerais {
				contato
				endereco
				sociais {
					facebook
					instagram
					linkedin
					vemSer
				}
			}
		}
	}
`

export function Footer() {
	const [offsetLeft, setOffsetLeft] = useState(0)
	const { data, loading, error } = useQuery(footerQuery)

	useEffect(() => {
		const wrapper = document.querySelector('.wrapper')
		document.addEventListener('scroll', () =>
			setOffsetLeft(wrapper.offsetLeft)
		)
		setOffsetLeft(wrapper.offsetLeft)
	}, [])

	if (loading || error) return <></>

	const endereco = data.acfOptionsDefinicoes.gerais.endereco
	const contato = data.acfOptionsDefinicoes.gerais.contato
	const sociais = data.acfOptionsDefinicoes.gerais.sociais

	return (
		<motion.footer
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			style={{
				paddingLeft: `${offsetLeft}px`,
				paddingRight: `${offsetLeft}px`,
			}}
			className="footer"
		>
			<motion.div className="footer__top">
				<motion.figure className="footer__logo">
					<Logo simple={true} />
				</motion.figure>
			</motion.div>
			<motion.div className="footer__bottom">
				<motion.div className="footer__block">
					<p>Endereço</p>
					<span dangerouslySetInnerHTML={{ __html: endereco }} />
				</motion.div>
				<motion.div className="footer__block">
					<p>Contato</p>
					<span dangerouslySetInnerHTML={{ __html: contato }} />
				</motion.div>
				<motion.div className="footer__block">
					<p>Nos acompanhe</p>
					<span>
						<Link target="_blank" to={sociais.facebook}>
							<SVG src={facebookIcon} />
						</Link>
						<Link target="_blank" to={sociais.instagram}>
							<SVG src={instagramIcon} />
						</Link>
						<Link target="_blank" to={sociais.linkedin}>
							<SVG src={linkedinIcon} />
						</Link>
						<Link target="_blank" to={sociais.vemSer}>
							<SVG src={vemSerIcon} />
						</Link>
					</span>
				</motion.div>
				<motion.div className="footer__block">
					<p>
						Voltar ao topo
						<motion.button
							initial="initial"
							whileHover="hover"
							whileTap="tap"
							onClick={() => window.scrollTo(0, 0)}
							variants={{
								tap: {
									transition: {
										duration: 0.05,
									},
								},
							}}
							className="footer__back"
						>
							<motion.svg viewBox="0 0 60 60" fill="none">
								<motion.circle
									cx="30"
									cy="30"
									r="29"
									stroke="#FFF"
									strokeWidth="2"
									strokeDasharray="1 10"
									variants={{
										initial: {
											pathLength: 1,
											fill: '#FFFFFF00',
										},
										hover: {
											pathLength: 0,
										},
										tap: {
											fill: '#FFFFFFFF',
										},
									}}
								/>
								<motion.path
									d="M31.6752 43.881V20.9055L41.9664 31.1966L44.3596 28.8033L29.9999 14.4436L15.6402 28.8033L18.0335 31.1966L28.3246 20.9055V43.881H31.6752Z"
									fill="#FFF"
									variants={{
										initial: {
											scale: 1,
											fill: '#FFFFFF',
										},
										hover: {
											scale: 1.5,
										},
										tap: {
											scale: 1.3,
											fill: '#000561',
										},
									}}
								/>
							</motion.svg>
						</motion.button>
					</p>
				</motion.div>
			</motion.div>
		</motion.footer>
	)
}
